export const NotificationActions = {
    NotificationError: 'NotificationError',
    NotificationInfo: 'NotificationInfo',
    NotificationSuccess: 'NotificationSuccess',
    NotificationWarning: 'NotificationWarning'
};